<section class="ac-accordion" [ngClass]="customClasses">
	<ng-content></ng-content>
</section>
